<script setup lang="ts">
    import {
        Dialog,
        DialogBody,
        DialogContent,
        DialogHeader,
        DialogTitle,
    } from '@/components/ui/dialog';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import type { OnboardingStep as OnboardingStepType } from '@/types';
    import OnboardingAssistant from './OnboardingAssistant.vue';

    const { t } = useI18n();

    const props = defineProps<{
        onboardingSteps: OnboardingStepType[];
        companyId: number;
        modelValue?: boolean;
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: boolean];
    }>();

    const open = computed({
        get: () => props.modelValue ?? false,
        set: (value) => emit('update:modelValue', value),
    });

    const handleCompleted = (incompleteSteps: number) => {
        if (incompleteSteps > 0) {
            open.value = false;
        }
    };
</script>

<template>
    <Dialog
        :open="open"
        @update:open="(value) => (open = value)"
    >
        <DialogContent class="flex flex-col sm:min-h-[700px] sm:max-w-2xl">
            <DialogHeader>
                <DialogTitle>
                    {{ t('onboarding.assistant.title') }}
                </DialogTitle>
            </DialogHeader>

            <DialogBody class="flex flex-col">
                <OnboardingAssistant
                    ref="assistant"
                    :onboarding-steps="onboardingSteps"
                    :company-id="companyId"
                    v-model="open"
                    @completed="handleCompleted"
                    @close="open = false"
                />
            </DialogBody>
        </DialogContent>
    </Dialog>
</template>
